import React from 'react'
import { Helmet } from 'react-helmet-async'
import { ManageAccountLayout } from '../../layouts'

const ManageAccountPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Manage Account</title>
      <meta name="description" content="Manage Account page" />
    </Helmet>
    <ManageAccountLayout />
  </React.Fragment>
)

export default ManageAccountPage
